import * as React from 'react'

import { SectionLayout } from './styles'

export const Center: React.FC<{ children?: React.ReactNode }> = ({ children, ...rest }) => (
  <SectionLayout role='region' aria-label='Center Site Header' location='center' {...rest}>
    {children}
  </SectionLayout>
)
